import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import MachineList from "./MachineList";
import MachineInfo from "./MachineInfo";
import UserResponse from "./UserResponse";
import CreateMachine from "./CreateMachine";
import Dashboard from "./Dashboard";
import { useSelector } from "react-redux";
import SiteList from "./SiteList";
import CreateSite from "./CreateSite";
import SiteInfo from "./SiteInfo";
import SiteUserSingleResponse from "./SiteUserSingleResponse";
import SiteDashBoard from "./pages/site/SiteDashboard";
import FreezerFrostDashboard from "./pages/freezerFrost/FreezerFrostDashboard";
import FreezerFrostList from "./pages/freezerFrost/FreezerFrostList";
import FreezerFrostCreate from "./pages/freezerFrost/FreezerFrostCreate";
import FreezerFrostInfo from "./pages/freezerFrost/FreezerFrostInfo";
import FreezerSessionDetail from "./pages/freezerFrost/FreezerSessionDetail";
import CreateSiteV2 from "./forms/CreateSiteV2";

const AppRouter = () => {
  const userData = useSelector((state) => state.userSlice);
  const groupId = userData?.user?.group?.uuid;
  let defaultRoute = `/dashboard/${groupId}`;

  return (
    <Routes>
      <Route path="/machine-list/view/:groupId" element={<MachineList />} />
      <Route path="/machine-list/:type" element={<CreateMachine />} />
      <Route path="/machine-info/:uuid" element={<MachineInfo />} />
      <Route path="/user-response/:responseId/:machineId" element={<UserResponse />} />
      <Route path="/dashboard/:groupId" element={<Dashboard />} />
      {/* Site Routes */}
      <Route path="/site/user-response/:responseId" element={<SiteUserSingleResponse />} />
      <Route path="/site-info/:uuid" element={<SiteInfo />} />
      <Route path="/site-list/:type" element={<CreateSite />} />
      <Route path="/site-list/view/:groupId" element={<SiteList />} />
      <Route path="/s/dashboard/:groupId" element={<SiteDashBoard />} />
      <Route path="/ff/dashboard/:groupId" element={<FreezerFrostDashboard />} />
      <Route path="/ff/list/view/:groupId" element={<FreezerFrostList />} />
      <Route path="/ff/create" element={<FreezerFrostCreate />} />
      <Route path="/ff/edit/:type" element={<CreateSiteV2 mode="freezer" />} />
      <Route path="/ff/info/:uuid" element={<FreezerFrostInfo />} />
      <Route path="/ff/session/:sessionId" element={<FreezerSessionDetail />} />
      <Route path="*" element={<Navigate to={defaultRoute} />} />
    </Routes>
  );
};

export default AppRouter;
